import { render, staticRenderFns } from "./Equipment.vue?vue&type=template&id=585b1af1"
import script from "./Equipment.vue?vue&type=script&lang=js"
export * from "./Equipment.vue?vue&type=script&lang=js"
import style0 from "./Equipment.vue?vue&type=style&index=0&id=585b1af1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports